<div class="internal-release-notes">
    <h1 i18n="@@internal-release-notes.title">Internal release notes</h1>

    <div class="version" *ngFor="let version of history">
        <h2>Version: {{ version.name }}</h2>

        <table class="version-info">
            <!-- <tr>
                <td>Latest changset date</td>
                <td>{{ version.latestChangesetDate | date: 'longDate'}}</td>
            </tr> -->
            <tr>
                <td i18n="@@internal-release-notes.oldBaseline">Old baseline</td>
                <td>{{ version.oldBaseline }} ({{ version.oldBaselineDate }})</td>
            </tr>
            <tr>
                <td i18n="@@internal-release-notes.newBaseline">New baseline</td>
                <td>{{ version.newBaseline }} ({{ version.newBaselineDate }})</td>
            </tr>
        </table>

        <h3 i18n="@@internal-release-notes.subtitle.changes">Changes</h3>
        <clx-accordion>
            <clx-accordion-item class="workitem" *ngFor="let workItem of version.workItems; let first = first;" topic="WorkItem: {{workItem.id}} - {{workItem.label}}" state="{{first == true ? 'opened' : 'closed'}}">
                <clx-row>
                    <h3>
                        <a class="workitemtitle" target="_blank"
                            href="{{workItem.url}}resource/itemName/com.ibm.team.workitem.WorkItem/{{workItem.id}}">{{workItem.id}} - {{workItem.label}}</a>
                    </h3>
                </clx-row>
                <clx-row>
                    <label class="changeset-label" i18n="@@internal-release-notes.changesets">Changesets:</label>
                </clx-row>
                <ul>
                    <li class="changeset" *ngFor="let changeset of workItem.changesets">
                        <a target="_blank"
                            href="{{changeset.url}}resource/itemOid/com.ibm.team.scm.ChangeSet/{{changeset.uuid}}">{{changeset.comment}}</a>
                    </li>
                </ul>
            </clx-accordion-item>
        </clx-accordion>
    </div>
</div>